export const getEStoreHomePageList = state => {
    return state.list
}

export const getEStoreHomePageDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreHomePage/getters.js